enum TokenizeErrorTargetType {
  FORM_FIELD = 'FORM_FIELD',
}

enum TokenizeErrorCode {
  PARAM_IS_INVALID = 'PARAM_IS_INVALID',
}

export interface TokenizeError {
  message: string
  reason_code: TokenizeErrorCode
  target: string[]
  target_type: TokenizeErrorTargetType
}

function tokenizeErrorMessage(
  tokenizeErrors: TokenizeError[] | { error_code: string; details?: string; error_message: string }
): string {
  if ('error_code' in tokenizeErrors) {
    return 'error.modal.message_payment_failed'
  }

  const [tokenizeError] = tokenizeErrors
  if (!tokenizeError || !tokenizeErrors) {
    // return default message when array is empty
    return 'error.modal.message_payment_failed'
  }

  const isInvalidCard = tokenizeErrors.some((tokenizeErr: TokenizeError) => {
    return (
      tokenizeErr.reason_code === TokenizeErrorCode.PARAM_IS_INVALID &&
      tokenizeErr.target[0] === 'cc-number' &&
      tokenizeErr.target_type === TokenizeErrorTargetType.FORM_FIELD
    )
  })

  const isInvalidCVV = tokenizeErrors.some((tokenizeErr: TokenizeError) => {
    return (
      tokenizeErr.reason_code === TokenizeErrorCode.PARAM_IS_INVALID &&
      tokenizeErr.target[0] === 'cvv-number' &&
      tokenizeErr.target_type === TokenizeErrorTargetType.FORM_FIELD
    )
  })

  const isExpired = tokenizeErrors.some((tokenizeErr: TokenizeError) => {
    // true when errors include either of invalid expiration-month or year form fields
    return (
      (tokenizeErr.target[0] === 'expiration-month' ||
        tokenizeErr.target[0] === 'expiration-year') &&
      tokenizeErr.reason_code === TokenizeErrorCode.PARAM_IS_INVALID &&
      tokenizeErr.target_type === TokenizeErrorTargetType.FORM_FIELD
    )
  })

  if (isInvalidCard) {
    return 'error.modal.message_err_invalid_credit_card_number'
  }

  if (isExpired) {
    return 'error.modal.message_err_expired'
  }

  if (isInvalidCVV) {
    return 'error.modal.message_err_cvv_required'
  }

  return 'error.modal.message_payment_failed'
}

export { tokenizeErrorMessage }
